import React from 'react'
import { useImageBlobUrl } from 'hooks/useImageBlobUrl'
import Loader from 'components/Loader'

interface ImageWithBlobProps {
  src: string
  alt?: string
  className?: string
  height?: string
  width?: string
  style?: React.CSSProperties
  draggable?: boolean
}

export const ImageWithBlob: React.FC<ImageWithBlobProps> = ({
  src,
  alt = '',
  className,
  height,
  width,
  style,
  draggable
}) => {
  const { blobUrl, loading, error } = useImageBlobUrl(src)

  if (loading) {
    return (
      <div
        className={className}
        style={{
          ...style,
          height,
          width,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loader />
      </div>
    )
  }

  if (error || !blobUrl) {
    return (
      <div
        className={className}
        style={{
          ...style,
          height,
          width,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        Failed to load
      </div>
    )
  }

  return (
    <img
      src={blobUrl}
      alt={alt}
      className={className}
      height={height}
      width={width}
      style={style}
      draggable={draggable}
    />
  )
}
